/**
 * @deprecated Import from '@/components/shared/engine-logo' instead.
 * This re-export exists only for backward compatibility while consumers are migrated.
 */
export { EngineLogo } from '@/components/shared/engine-logo'
